<template>
    <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
            <v-btn
            v-if="display"
            fab
            :small="$vuetify.breakpoint.smAndDown"
            :large="$vuetify.breakpoint.mdAndUp"
            depressed
            class="mx-3"
            :light="!publisherVideo"
            :color="!publisherVideo ? 'white' : 'rgba(255,255,255, 0.2)'"
            @click="togglePublisherVideo"
            :disabled="!isConnected"
            v-bind="attrs"
            v-on="on"
            >
            <v-icon>{{ !publisherVideo ? 'mdi-video-off' : 'mdi-video' }}</v-icon>
            </v-btn>
        </template>
        <span>{{ !publisherVideo ? 'Turn on video' : 'Turn off video' }}</span>
    </v-tooltip>
</template>

<script>
export default {
    name: 'VideoButton',
    props: ['display', 'publisherVideo', 'isConnected'],
    methods: {
        togglePublisherVideo() {
            this.$emit('togglePublisherVideo')
        }
    }
}
</script>
